import { useTranslation } from "react-i18next";

import LoadingSpinner from "pstat-design-system/LoadingSpinner";
import { LoadingModal } from "pstat-design-system/modal/StyledReactModal";
import { Text } from "pstat-design-system/text";

const ShowChangesLoadingModal = ({ isOpen }) => {
  const { t } = useTranslation();
  const parentSelector = () =>
    document.getElementById("view-content") || document.body;
  return (
    <LoadingModal isOpen={isOpen} parentSelector={parentSelector}>
      <LoadingSpinner size={50} />
      <Text color="nav.25" fontWeight="medium" fontSize={1} pt={7}>
        {t("documentControl.showChangesLoading")}
      </Text>
    </LoadingModal>
  );
};

export default ShowChangesLoadingModal;
